import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const PREFIX = 'CompanyLogo';

const classes = {
  icon: `${PREFIX}-icon`,
  linkStyle: `${PREFIX}-linkStyle`
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.icon}`]: { color: theme.palette.primary.contrastText },

  [`& .${classes.linkStyle}`]: {
    color: alpha(theme.palette.primary.contrastText, 0.8),
    textDecoration: 'none'
  }
}));

interface CompanyLogoProps {
  companyName: string;
  tenant: string;
}

const CompanyLogo = ({ companyName, tenant }: CompanyLogoProps) => {
  return (
    <StyledGrid container wrap="nowrap" alignItems="center" spacing={1}>
      <Grid item>
        <RouterLink to={`/${tenant}/`}>
          <IconButton className={classes.icon} data-testid="home-button" size="large">
            <span className="appbar-logo" />
          </IconButton>
        </RouterLink>
      </Grid>
      <Grid item xs zeroMinWidth>
        <Typography variant="h6" noWrap>
          <RouterLink className={classes.linkStyle} to={`/${tenant}/`}>
            {companyName}
          </RouterLink>
        </Typography>
      </Grid>
    </StyledGrid>
  );
};

export default CompanyLogo;
